import type { StoreAppContextInterface } from '~/types/types'
import type { FriendsStorePorts, FriendsRelationStorePorts } from '~/domains/friends/FriendsService'

/**
 * Собирает узкий auth/diary/toasts port из $storeModules, которым уже владеет
 * вызывающий компонент. Возвращает новый объект с перечисленными членами
 * auth/diary/toasts, а не целые модули Vuex — вызывается на каждое обращение, а не
 * в module-scope константу, чтобы SSR не переиспользовал адаптер между запросами
 * разных пользователей. Каждый член состояния собран через get-аксессор на самом
 * себе, а не через аксессор на модуле целиком: доменный сервис деструктурирует
 * порт один раз (`const { diary } = ports`) и читает его поля дальше. setRelation —
 * метод класса DiaryStoreMod и опирается на this, поэтому оборачивается стрелкой.
 */
export function useFriendsStorePorts (
  storeModules: Pick<StoreAppContextInterface, 'auth' | 'diary' | 'toasts'>
): FriendsStorePorts {
  return {
    auth: {
      get userIdOrNull () {
        return storeModules.auth.userIdOrNull
      }
    },
    diary: {
      get currentUser () {
        return storeModules.diary.currentUser
      },
      setRelation: (...args: Parameters<StoreAppContextInterface['diary']['setRelation']>) =>
        storeModules.diary.setRelation(...args)
    },
    toasts: {
      addToast: (...args: Parameters<StoreAppContextInterface['toasts']['addToast']>) =>
        storeModules.toasts.addToast(...args)
    }
  }
}

/**
 * Собирает узкий auth port для fetchRelationRequestCount из $storeModules, которым
 * уже владеет вызывающий компонент.
 */
export function useFriendsRelationStorePorts (
  storeModules: Pick<StoreAppContextInterface, 'auth'>
): FriendsRelationStorePorts {
  return {
    auth: {
      get userIdOrNull () {
        return storeModules.auth.userIdOrNull
      }
    }
  }
}
